import { AllyNode } from "../../types";
import { AllyBase } from "../base";
import { AllyElementBase } from "./ally-element-base.class";
import { AllyAttribute } from "../ally-attribute.class";
import { AllyZone } from "../util";

/**
 * --- This class provides part of the function matrix created by the AllyElements object. ---
 *
 * Handles `mat-select` components so the keyboard activation added by AllyEnter does
 * not double-trigger them: it suppresses the click handler on the surrounding
 * `.mat-mdc-text-field-wrapper` and removes that wrapper from the tab order. The
 * Zone.js internal it reads is guarded, so it fails safe (skips suppression)
 * under zoneless change detection or if Angular Material changes its internals.
 *
 * @extends AllyElementBase
 * @see AllyElements
 */
export class AllySelect extends AllyElementBase {
    /**
     * @param bridge The bridge to the parent in the hierarchical tree.
     * @see AllyBase
     */
    constructor(bridge: () => AllyBase) {
        super(bridge, (matrix) => {
            matrix[0].push((scope) => {
                if (scope.self.library.angular.isSelect(scope.self)) {
                    let formField = document.querySelector('.mat-mdc-text-field-wrapper:has([adx-ally-id="' + scope.self.id + '"])');
                    if (formField) {
                        // Suppress the form-field wrapper's click handler so the added keyboard
                        // activation does not double-trigger the mat-select. AllyZone fails safe
                        // (skips suppression) under zoneless change detection or if Material
                        // changes its internals.
                        AllyZone.suppressFirstClickHandler(formField);
                        let object = scope.self.getObjectByNode(formField as AllyNode);
                        if (object) {
                            if (object.variables[object.id + "-select-index"] === undefined) {
                                object.variables[object.id + "-select-index"] = object.attribute.createIndex(2);
                            }
                            let index = object.variables[object.id + "-select-index"] as AllyAttribute["index"];
                            object.attribute.setAttribute("tabindex", index, "-1");
                        }
                    }
                }
            });
        }, 7);
    }
}